/*
  import { helpCenterDocumentStore } from '@/services/HelpDeskSubject/store'
*/

import Vue from 'vue'
import Vuex from 'vuex'
import { notifyProblem } from '@/services/notify'
import kms from '@/services/kms'

const isDebug = true

/* eslint-disable no-empty-pattern */
const actions = {
  /*
    const { list } = await helpDeskSubjectStore.dispatch ('getHelpDeskSubjectList'});
  */

  async getHelpCenterDocuentList({}) {
    console.log('in getHelpCenterDocuentList...')
    try {
      const results = await kms.get(`/HelpCenterDocuments/HelpCenterDocument/List`)

      if (isDebug == true) console.debug('getHelpCenterDocuentList log=' + JSON.stringify(results))

      return {
        list: results.results
      }
    } catch (exception) {
      notifyProblem(`The help desk documents list could not be retrieved.`)
      console.error(exception)
    }

    return {
      list: []
    }
  },

  async getDocumentFile({ dispatch }, { params, done }) {
    const path = `/HelpCenterDocuments/HelpCenterDocument/GetFile`
    const result = await kms.get(path, {
      params
    })

    if (this.isDebug == true) console.debug('getDocumentFile=' + JSON.stringify(result))

    if (dispatch && dispatch != undefined) console.debug(dispatch)

    if (result) {
      console.debug(`Successfully opened the help center document in a new tab.`)
      done({ details: result })
    } else {
      console.error('There was a problem opening the help center document.')
    }
  }
}
/* eslint-enable no-empty-pattern */

Vue.use(Vuex)
export const helpCenterDocumentStore = new Vuex.Store({
  state: {},
  mutations: {},
  getters: {},
  actions
})
